Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = exports.Info = exports.Context = exports.Inject = exports.injectorRegistry = void 0;
const registry_1 = require("./registry");
var registry_2 = require("./registry");
Object.defineProperty(exports, "injectorRegistry", { enumerable: true, get: function () { return registry_2.injectorRegistry; } });
function Inject(resolver) {
    return (target, fieldName, argIndex) => {
        registry_1.injectorRegistry.set(target.constructor, [fieldName, argIndex], resolver);
    };
}
exports.Inject = Inject;
exports.Context = Inject(({ context }) => {
    return context;
});
exports.Info = Inject(({ info }) => {
    return info;
});
exports.Source = Inject(({ source }) => {
    return source;
});
//# sourceMappingURL=Inject.js.map